import { formatCurrency, formatDate } from "./formatters";

// Fonction pour obtenir les informations de la société
export const getSocieteInfos = () => {
  try {
    const societe = localStorage.getItem("societe");
    if (societe) {
      return JSON.parse(societe);
    }
  } catch (error) {
    console.error("Erreur chargement société", error);
  }
  
  // Valeurs par défaut
  return {
    nom: "SAWD",
    adresse: "Libreville, Gabon",
    telephone: "+241 00 00 00 00",
    email: "contact@sawd.com",
    site_web: "www.sawd.com",
    rc: "RC123456",
    nif: "NIF123456",
    patente: "PAT123456"
  };
};

// Configuration des couleurs professionnelles (tons de gris)
export const COLORS = {
  primary: '#2c3e50',    // Bleu-gris foncé
  secondary: '#7f8c8d',   // Gris
  accent: '#3498db',      // Bleu clair (pour touches)
  success: '#27ae60',     // Vert
  warning: '#f39c12',     // Orange
  danger: '#e74c3c',      // Rouge
  light: '#ecf0f1',       // Gris très clair
  dark: '#2c3e50',        // Presque noir
  white: '#ffffff',
  black: '#000000'
};

// Styles communs pour les documents
export const getDocumentStyles = () => ({
  header: {
    fontSize: 24,
    bold: true,
    color: COLORS.primary,
    margin: [0, 0, 0, 20],
    alignment: 'center'
  },
  subHeader: {
    fontSize: 16,
    bold: true,
    color: COLORS.secondary,
    margin: [0, 10, 0, 10]
  },
  normal: {
    fontSize: 10,
    color: COLORS.dark
  },
  tableHeader: {
    fontSize: 11,
    bold: true,
    fillColor: COLORS.light,
    color: COLORS.primary,
    alignment: 'center'
  },
  tableCell: {
    fontSize: 10,
    margin: [5, 5, 5, 5]
  },
  footer: {
    fontSize: 8,
    color: COLORS.secondary,
    alignment: 'center',
    margin: [0, 20, 0, 0]
  },
  infoBox: {
    margin: [0, 10, 0, 10],
    padding: [10, 10, 10, 10],
    border: true,
    borderColor: COLORS.light
  }
});